import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import { ChevronDown, LogOut, User, } from "lucide-react";
import defaultImg from "../../assets/default.jpeg";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import AttendanceToggle from "../../pages/AttandanceToggle";
import GrievanceCreate from "../Grievence/GrievanceCreate";
import { flushSync } from "react-dom";
import ansHrImg from "../../assets/ANS-Logo.svg";


const Navigation = () => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isTaskDropdownOpen, setIsTaskDropdownOpen] = useState(false);
  const [isDemoDropdownOpen, setIsDemoDropdownOpen] = useState(false);
  const [isExpenceDropdownOpen, setIsExpenceDropdownOpen] = useState(false);
  const [isEmployeGrievenceDropdownOpen, setIsEmployeGrievenceDropdownOpen] = useState(false);


  const [, setGravenceDropdownOpen] = useState(false);

  const [isEmployeeDropdownOpen, setIsEmployeeDropdownOpen] = useState(false);
  // const [isActive, setIsActive] = useState(false);
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // const [isPresentActive, setIsPresentActive] = useState(false);
  // const [isLeaveActive, setIsLeaveActive] = useState(false);

  const dropdownRef = useRef(null);
  const taskDropdownRef = useRef(null);
  const demoDropdownRef = useRef(null);
  const expenceDropdownRef = useRef(null);
  const gravenceDropdownRef = useRef(null);
  const employeeDropdownRef = useRef(null);
  const employeeGrievenceDropdownRef = useRef(null);

  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();
  const { logout, user, isAuthenticated } = useAuth();
  // const API_URL = process.env.REACT_APP_API_URL

  // const notificationCount = 3;
  const isEmployee = user?.role === "employee";
  const employeeId = user?.employeeProfile?.employeeId ?? "";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (
        employeeDropdownRef.current &&
        !employeeDropdownRef.current.contains(event.target)
      ) {
        setIsEmployeeDropdownOpen(false);
      }
      if (
        taskDropdownRef.current &&
        !taskDropdownRef.current.contains(event.target)
      ) {
        setIsTaskDropdownOpen(false);
      }
      if (
        demoDropdownRef.current &&
        !demoDropdownRef.current.contains(event.target)
      ) {
        setIsDemoDropdownOpen(false);
      }
      if (
        gravenceDropdownRef.current &&
        !gravenceDropdownRef.current.contains(event.target)
      ) {
        setGravenceDropdownOpen(false);
      }
      if (
        expenceDropdownRef.current &&
        !expenceDropdownRef.current.contains(event.target)
      ) {
        setIsExpenceDropdownOpen(false);
      }
      if (
        employeeGrievenceDropdownRef.current &&
        !employeeGrievenceDropdownRef.current.contains(event.target)
      ) {
        setIsEmployeGrievenceDropdownOpen(false);
      }

    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setIsDropdownOpen(false);
    flushSync(() => {
      logout();
    });
    navigate("/login");
  };

  // const [isPresentDisabled, setIsPresentDisabled] = useState(false);
  // const [isLeaveDisabled, setIsLeaveDisabled] = useState(false);

  // const handleAttendanceToggle = async (type) => {
  //   const attendanceDate = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);

  //   try {
  //     const res = await axios.post(`${API_URL}attendance`, {
  //       employeeId: user.employeeProfile._id,
  //       attendanceDate,
  //       type, // "P" or "L"
  //     });

  //     if (res.data.success) {
  //       toast.success(res.data.message);

  //       if (type === "P") {
  //         setIsPresentActive(true);
  //         setIsPresentDisabled(true); // cannot click again
  //         setIsLeaveDisabled(true);   // disable Leave
  //       } else {
  //         setIsLeaveActive(true);
  //         setIsLeaveDisabled(true);
  //         setIsPresentDisabled(true); // disable Present
  //       }
  //     } else {
  //       toast.error(res.data.message);
  //     }
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || "Error marking attendance");
  //   }
  // };




  // const AttendanceToggle = ({ isActive, isButtonDisabled, onToggle }) => {
  //   return (
  //     <button
  //       type="button"
  //       disabled={isButtonDisabled}
  //       onClick={onToggle}
  //       className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 
  //       ${isActive ? "bg-green-500" : "bg-gray-300"} 
  //       ${isButtonDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
  //     `}
  //     >
  //       <span
  //         className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 
  //         ${isActive ? "translate-x-6" : "translate-x-1"}
  //       `}
  //       />
  //     </button>
  //   );
  // };

  // useEffect(() => {
  //   const fetchTodayAttendance = async () => {
  //     try {
  //       const res = await axios.get(`${API_URL}attendance?employeeId=${user.employeeProfile._id}`);
  //       const records = res.data.data;

  //       if (records && records.length > 0) {
  //         // Get start of today in epoch
  //         const startOfDay = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
  //         const endOfDay = Math.floor(new Date().setHours(23, 59, 59, 999) / 1000);

  //         // Find today's attendance
  //         const today = records.find(
  //           (rec) => rec.attendanceDate >= startOfDay && rec.attendanceDate <= endOfDay
  //         );

  //         if (today) {
  //           setIsPresentActive(today.present);
  //           setIsLeaveActive(today.leave);
  //           setIsPresentDisabled(today.present);
  //           setIsLeaveDisabled(today.leave);
  //         } else {
  //           setIsPresentActive(false);
  //           setIsLeaveActive(false);
  //           setIsPresentDisabled(false);
  //           setIsLeaveDisabled(false);
  //         }
  //       } else {
  //         setIsPresentActive(false);
  //         setIsLeaveActive(false);
  //         setIsPresentDisabled(false);
  //         setIsLeaveDisabled(false);
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   fetchTodayAttendance();
  // }, []);




  if (!isAuthenticated) return null;

  return (
    <>
      <nav className="bg-white  shadow-md top-0 left-0 right-0 z-10">
        <div className="w-full mx-auto px-4">
          <div className="flex justify-between h-16 items-center">
            {/* Logo and Navigation Links */}
            <div className="flex items-center space-x-2">
              <Link to="/" className="text-2xl font-bold text-[#2C4E86]">
                <img src={ansHrImg} alt="anshrImage" className="w-28 object-contain" />
              </Link>
              <div className="hidden md:flex ">
                {!isEmployee && (
                  <>
                    {/* Employee Dropdown */}
                    <div ref={employeeDropdownRef} className="relative inline-block">
                      <button
                        onClick={() =>
                          setIsEmployeeDropdownOpen(!isEmployeeDropdownOpen)
                        }
                        className="text-gray-700 text-start hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                      >
                        Employee Management
                        <ChevronDown size={19} />
                      </button>
                      {isEmployeeDropdownOpen && (
                        <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                          <Link
                            to="/employee/create"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => setIsEmployeeDropdownOpen(false)}
                          >
                            Create
                          </Link>
                          <Link
                            to="/employee/list"
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => setIsEmployeeDropdownOpen(false)}
                          >
                            List
                          </Link>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {/* Task Dropdown */}
                <div ref={taskDropdownRef} className="relative inline-block">
                  <button
                    onClick={() => setIsTaskDropdownOpen(!isTaskDropdownOpen)}
                    className="text-gray-700 text-start hover:text-blue-900 px-3 py-2 rounded-md text-sm flex items-center"
                  >
                    Task Management
                    <ChevronDown size={19} />

                  </button>
                  {isTaskDropdownOpen && (
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                      <Link
                        to="/task/create"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsTaskDropdownOpen(false)}
                      >
                        Create
                      </Link>
                      <Link
                        to="/view-all-tasks"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsTaskDropdownOpen(false)}
                      >
                        Reports
                      </Link>
                    </div>
                  )}
                </div>

                {/* Demo Dropdown */}



                <div ref={demoDropdownRef} className="relative inline-block">
                  <button
                    onClick={() => setIsDemoDropdownOpen(!isDemoDropdownOpen)}
                    className="text-gray-700 hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                  >
                    Function
                    <ChevronDown size={19} />

                  </button>
                  {isDemoDropdownOpen && (
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                      <Link
                        to="/demo/create"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsDemoDropdownOpen(false)}
                      >
                        Create
                      </Link>
                      <Link
                        to="/demo/reports"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsDemoDropdownOpen(false)}
                      >
                        Reports
                      </Link>
                      {user?.role !== "employee" && (
                        <Link
                          to="/demo/attandance"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => setIsDemoDropdownOpen(false)}
                        >
                          Center Attandance
                        </Link>
                      )}
                    </div>
                  )}
                </div>


                {/* Expenses Dropdown */}
                <div ref={expenceDropdownRef} className="relative inline-block">
                  <button
                    onClick={() =>
                      setIsExpenceDropdownOpen(!isExpenceDropdownOpen)
                    }
                    className="text-gray-700 hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                  >
                    Expenses
                    <ChevronDown size={19} />

                  </button>
                  {isExpenceDropdownOpen && (
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                      <Link
                        to="/expences/add"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsExpenceDropdownOpen(false)}
                      >
                        Add Expenses

                      </Link>
                      <Link
                        to="/expences/report"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => setIsExpenceDropdownOpen(false)}
                      >
                        Report
                      </Link>
                    </div>
                  )}
                </div>

                {/* <div className="relative inline-block">
                  <button
                    onClick={() => navigate("/attendanceList")

                    }
                    className="text-gray-700 hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                  >
                    Attendance List

                  </button>
                </div> */}


                {/* Grievance for Admin & HR */}
                {!isEmployee && (
                  <div >
                    <button
                      onClick={() => navigate('/grievence-list')} // Navigate on click
                      className="text-gray-700 hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                    >
                      Grievance

                    </button>
                  </div>
                )}

                {/* Grievence for Employee */}
                {isEmployee && (
                  <div ref={employeeGrievenceDropdownRef} className="relative inline-block">
                    <button
                      onClick={() => setIsEmployeGrievenceDropdownOpen(!isEmployeGrievenceDropdownOpen)}
                      className="text-gray-700 hover:text-blue-900 px-3 py-2 text-sm rounded-md flex items-center"
                    >
                      Grievance
                      <ChevronDown size={19} />

                    </button>
                    {isEmployeGrievenceDropdownOpen && (
                      <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                        <Link
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => {
                            setIsEmployeGrievenceDropdownOpen(false); // close dropdown
                            setOpenDialog(true);
                          }} >
                          Create
                        </Link>
                        <Link
                          to="/grievence-list"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                          onClick={() => setIsEmployeGrievenceDropdownOpen(false)}
                        >
                          Reports
                        </Link>

                      </div>
                    )}
                  </div>
                )}

              </div>
            </div>

            {/* Profile & Notifications */}
            <div className="flex px-3 gap-5 items-center">
              {/* <div className="relative cursor-pointer">
                <Bell className="w-6 h-6 text-gray-700" />
                {notificationCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-4 h-4 flex items-center justify-center rounded-full">
                    {notificationCount}
                  </span>
                )}
              </div> */}

              <div ref={dropdownRef} className="relative">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center space-x-2 text-gray-700 hover:text-gray-900 focus:outline-none"
                >
                  <img
                    src={
                      user?.employeeProfile?.employeePhoto &&
                        user?.employeeProfile?.employeePhoto.trim() !== ""
                        ? user?.employeeProfile?.employeePhoto
                        : defaultImg
                    }
                    alt="Profile"
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <span className="hidden md:block">{user?.name || "User"}</span>
                  <ChevronDown size={19} />

                </button>

                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-2 z-20 flex flex-col gap-2 px-2">
                    {/* 🔹 My Profile Button */}
                    {isEmployee && (
                      <Link
                        to={`/employee/view/${employeeId}`}
                        className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-4 py-2"
                      >
                        <User className="text-blue-500 w-5 h-5" />
                        <span className="text-sm text-gray-700">My Profile</span>
                      </Link>
                    )}

                    {/* 🔹 Logout Button */}
                    <button
                      onClick={handleLogout}
                      className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-4 py-2 text-sm text-gray-700 w-full"
                    >
                      <LogOut className="text-red-500 w-5 h-5" />
                      <span>Logout</span>
                    </button>

                    {/* 🔹 Attendance Toggle — visible only from 9:00 PM to 10:30 PM */}
                    {/* 🔹 Attendance Toggles (P & L) */}
                    {/* {isEmployee && (
                      <div className="flex flex-col gap-2 py-2">
                        <div className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                          <span className="text-sm font-medium text-gray-700">Present</span>
                          <AttendanceToggle
                            isActive={isPresentActive}
                            isButtonDisabled={isPresentDisabled || isLeaveActive} // disable if Leave is active
                            onToggle={() => handleAttendanceToggle("P")}
                          />
                        </div>

                        <div className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                          <span className="text-sm font-medium text-gray-700">Leave</span>
                          <AttendanceToggle
                            isActive={isLeaveActive}
                            isButtonDisabled={isLeaveDisabled || isPresentActive} // disable if Present is active
                            onToggle={() => handleAttendanceToggle("L")}
                          />
                        </div>
                      </div>
                    )} */}
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </nav >
      <GrievanceCreate
        open={openDialog}
        onClose={() => setOpenDialog(false)}

      />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Navigation;
